/**
 * 서버 시각을 해석하는 **단 하나의 자리**.
 *
 * 서버는 타임존 없는 ISO 를 줍니다 (실측: `2026-09-10T15:04:08.589150`).
 * `Date.parse` 로 그냥 읽으면 브라우저가 **로컬 시각**으로 해석합니다 —
 * 한국(UTC+9)에서는 아홉 시간이 어긋납니다.
 *
 * 이 규칙은 이 제품에서 세 번 깨졌습니다. 현장 정보가 아홉 시간 일찍
 * 사라졌고, 이벤트 D-day 가 틀어졌고, 확인일이 하루 어긋났습니다. 그래서
 * `datetime-policy` 검사가 `Date.parse` 를 아예 막고 있는데, 그 예외 목록에
 * **같은 규칙의 사본 둘**이 들어 있었습니다 — `utils/datetime.ts` 와
 * `domain/live.ts`. 오늘은 두 사본이 같았지만, 같은 규칙을 두 곳에 두면
 * 언젠가 한쪽만 고쳐집니다.
 *
 * 여기가 원본입니다. `@oshimap/utils` 의 `parseServerDate` 는 이것을 다시
 * 내보냅니다 — 부르는 쪽 코드는 그대로입니다.
 *
 * 오늘 날짜(`todayISODate`)는 **다른 일**이라 여기 없습니다. 그것은 보는
 * 사람의 달력이고, 이것은 서버가 말한 순간입니다.
 */
const HAS_ZONE = /[zZ]|[+-]\d{2}:?\d{2}$/;

/** 밀리초. 못 읽으면 `NaN` 입니다. */
export function serverTimeMs(v: string): number {
  return Date.parse(HAS_ZONE.test(v) ? v : `${v}Z`);
}

export function parseServerDate(v?: string | null): Date | null {
  if (!v) return null;
  const t = serverTimeMs(v);
  return Number.isFinite(t) ? new Date(t) : null;
}
